export const deliveryFeeConstants = {
  'messages': {
    'API_ERROR': 'Algo deu errado, por favor verifique seu CEP',
    'CALCULATE': 'Calcular',
    'CLOSE': 'Fechar',
    'EDIT': 'editar',
    'TITLE': 'Calcular frete',
    'TYPE_CEP': 'Digite o CEP',
    'VALUE_REGION': 'Valor do frete para a região:',
  }
}
